exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "button.btn-fullscreen {\n    position: absolute;\n    right: 0px;\n    margin: 15px 15px 0 0;\n    z-index: 10000;\n}\n.container{\n  width: 90vw !important;\n}\n.fullscreen{\n  width: 100% !important;\n}\n@media only screen and (max-width: 768px){\n  .container{\n    width: 100% !important;\n  }\n}\n#main-c:fullscreen,\n#main-c:-webkit-full-screen\n#main-c:-moz-full-screen\n#main-c:-ms-fullscreen{\n  width: 100%;\n  height: 100%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = 747
// module chunks = 0